export default __webpack_public_path__ + "static/media/bitcoinpk.f877179f.webp";